export function makeTall() {
    $(this).find(".category_description_1").fadeIn(200);
    $(this).find(".category-icon").fadeIn(200);
    $(this).find("ul.dropdown-menu.level_2").fadeIn(150);
}